var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Menu } from "@headlessui/react";
import { classNames } from "../../Util";
var iconSizing = "mr-3 h-5 w-5";
var Buttons = function (_a) {
    var group = _a.group;
    var items = group.map(function (btn, i) { return (_jsx(Menu.Item, { children: function (_a) {
            var active = _a.active;
            return (_jsxs("button", __assign({ disabled: btn.disabled, onClick: btn.onClick, className: classNames("group flex items-center px-4 py-2 text-sm w-full text-left", active
                    ? "bg-gray-100 ".concat(btn.type === "danger" ? "text-red-500" : "text-gray-700")
                    : (btn.type === "danger" ? "text-red-500" : "text-gray-700"), btn.disabled ? "text-opacity-50" : "") }, { children: [btn.icon ?
                        _jsx(btn.icon, { className: classNames("shrink-0", iconSizing, btn.type === "danger" ? "text-red-400" : "text-gray-400", !btn.disabled
                                ? (btn.type === "danger" ? "group-hover:text-red-500" : "group-hover:text-gray-500")
                                : "text-opacity-50"), "aria-hidden": "true" })
                        : _jsx("div", { className: classNames("shrink-0", iconSizing) }), btn.text] })));
        } }, i)); });
    return (_jsx(_Fragment, { children: items }));
};
export default Buttons;
